<!--
 * @Description: 
 * @Author: jinxiaojian
 * @Email: jinxiaojian@youxin.com
 * @Date: 2019-07-10 16:43:15
 * @LastEditTime: 2019-07-11 16:42:08
 * @LastEditors: 焦丙乾(jiaobingqian)
 -->
 <template>
  <div></div>
</template>

<script>
export default {
  props: ["downFun"],
  watch: {
    downFun(val) {
      if (val) {
        this.openIframeApp();
      }
    },
  },
  methods: {
    openIframeApp() {
      function getQueryVariable(word) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == word) {
            return pair[1];
          }
        }
        return false;
      }
      var ua = navigator.userAgent.toLowerCase();
      var platform = {
        // android终端或者uc浏览器
        android: ua.indexOf("android") > -1 || ua.indexOf("linux") > -1,
        androidVersion: 0,
        // 是否为iPhone或者QQHD浏览器
        iPhone: ua.indexOf("iphone") > -1,
        // 是否iPadip
        iPad: ua.indexOf("ipad") > -1,
        //ios version
        iosVersion: 0,
        //windows phone
        wPhone: ua.indexOf("windows phone") > -1,
        //是否在 微信 客户端内
        isWeixin: ua.indexOf("micromessenger") > -1,
        isVivo: ua.indexOf("vivo") > -1,
        mfAndroid:
          ua.indexOf("android") > -1 ||
          ua.indexOf("adr") > -1 ||
          ua.indexOf("linux") > -1,
        mfAldb: ua.indexOf("magicloan") > -1,
      };

      var out = /iphone os (\d+)/.exec(ua);
      if (out) {
        platform.iosVersion = parseInt(out[1], 10);
      } else if ((out = /android (\d+)/.exec(ua))) {
        platform.androidVersion = parseInt(out[1], 10);
      }

      //针对ios客户端屏蔽操作
      var browserHidden = function() {
        if (typeof document.hidden !== "undefined") {
          return document.hidden;
        } else if (typeof document.mozHidden !== "undefined") {
          return document.mozHidden;
        } else if (typeof document.msHidden !== "undefined") {
          return document.msHidden;
        } else if (typeof document.webkitHidden !== "undefined") {
          return document.webkitHidden;
        }
        return false;
      };

      //下面代码来自网络,创建一个iframe,延迟后判断是否页面跳转了
      function callNative(url, callback, universalLinks) {
        if (!url) {
          return;
        }

        var oFrame = document.createElement("iframe");
        oFrame.style.display = "none";
        var body = document.body;
        var timer;
        var clear = function(evt, isTimeout) {
          typeof callback === "function" && callback(isTimeout);
          window.removeEventListener("pagehide", hide, true);
          if (!oFrame) {
            return;
          }

          oFrame.onload = null;
          body.removeChild(oFrame);
          oFrame = null;
        };
        var hide = function(e) {
          clearTimeout(timer);
          clear(e, false);
        };
        var timer1 = 70,
          timer2 = 1200,
          timerDuration = 1300;

        window.addEventListener("pagehide", hide, true);
        if (platform.iosVersion >= 9) {
          oFrame = null;
          if (universalLinks && this.options.isDebug) {
            window.location.href = universalLinks;
          } else {
            window.location.href = url;
          }
        } else {
          oFrame.onload = clear;
          oFrame.src = url == "http://haohuan" ? "haohuan://" : url;
          body.appendChild(oFrame);
        }

        var startTime = +new Date();
        timer = setTimeout(function() {
          timer = setTimeout(function() {
            var newTime = +new Date();
            var duration = newTime - startTime;
            if (duration > timerDuration) {
              clear(null, false);
            } else if (!browserHidden()) {
              clear(null, true);
            }
          }, timer2);
        }, timer1);
      }
      let downloadType = getQueryVariable("downloadType") || "mobile";
      let phone = getQueryVariable("phone");
      !(function() {
        var YING_YONG_BAO_URL =
          "http://sj.qq.com/myapp/detail.htm?apkName=com.renrendai.haohuan";
        var appStoreURL = "https://itunes.apple.com/cn/app/id1309415987?mt=8"; //主包
        // var appStoreURL = 'https://itunes.apple.com/app/id1225459029?mt=8';//马甲包
        var androidDownloadURL = `https://d.weicai.com.cn/download/android/haohuan_release.apk`;

        var APP_SCHEMA = "http://haohuan";
        // var APP_SCHEMA = "haohuan://";
        var universalLinks = "https://api-m.haohuan.com?debug=true";

        if (platform.mfAndroid && platform.mfAldb) {
          // window.isMFXJJB = true;
          APP_SCHEMA = "aldb://magincloan?v=1.1&p=haohuan://";
          androidDownloadURL =
            "aldb://magincloan?v=1.1&p=https://d.weicai.com.cn/download/android/haohuan_release.apk";
        }
        var isxjbk = getQueryVariable("xjbk");
        if (isxjbk) {
          //都是马甲包，后面正式包上线需要替换
          androidDownloadURL =
            "https://hn.xianjincard.com/download?url=https://d.weicai.com.cn/download/android/haohuan_release.apk";
          appStoreURL =
            "itms-appss://itunes.apple.com/cn/app/id1309415987?mt=8";
        }

        if (platform.wPhone) {
          alert("抱歉，暂不支持您的设备");
          return;
        }

        var finalDownloadURL = androidDownloadURL;

        if (platform.iPhone || platform.iPad) {
          APP_SCHEMA = "haohuan://";
          finalDownloadURL = appStoreURL;
          if (!platform.isWeixin) {
            if (getQueryVariable("utm_source") == "xrqb") {
              appStoreURL =
                "itms-appss://itunes.apple.com/cn/app/id1309415987?mt=8";
            } else {
              appStoreURL = "https://itunes.apple.com/cn/app/id1309415987?mt=8";
            }
            window.location.href = appStoreURL;
            return false;
          }
        }

        if (platform.isWeixin) {
          APP_SCHEMA = null;
          finalDownloadURL = YING_YONG_BAO_URL;
        }
        if (platform.android && platform.isVivo) {
          APP_SCHEMA = null;
          finalDownloadURL =
            "market://details?id=com.renrendai.haohuan&th_name=com.renrendai.haohuan";
        }
        if (APP_SCHEMA) {
          if (
            finalDownloadURL.indexOf(
              "https://d.weicai.com.cn/download/android/haohuan_release.apk",
            ) >= 0
          ) {
            window.location.href = finalDownloadURL;
            return false;
          }
          //先尝试调起本地APP
          callNative(
            APP_SCHEMA,
            function(isTimeout) {
              if (isTimeout) {
                setTimeout(function() {
                  window.location.href = finalDownloadURL;
                }, 0);
              } else {
                window.location.href = finalDownloadURL;
                return false;
              }
            },
            universalLinks,
          );
        } else {
          window.location.href = finalDownloadURL;
        }
      })();
    },
  },
};
</script>

